<!-- Selected state -->
@if (resolvedUser()) {
  <aw-avatar
    [image]="image()"
    [text]="resolvedUser() | userDisplayName"
    [showLabel]="showLabel()"
    [size]="size()"
    [class]="classes()"
    [showInitials]="!resolvedUser()?.hasImage"
    [initials]="resolvedUser()?.initials"
  />
}

<!-- Empty state -->
@if (!resolvedUser()) {
  <aw-icon-button [size]="'s'" [disabled]="disabled()" [icon]="'person'" [class]="classes()" />
}
